import React, {  useEffect, useState } from "react";
import {
  Loader,
  Text,
} from "@mantine/core";
import fetchApi from "../Lib/api";
import { useParams } from "react-router-dom";
import moment from "moment";
import HeaderAndSidebar from "../Lib/HeaderAndSidebar";
import {
  handleFollowUnfollow,
} from "../Dashbaord/DashboardPages/Members";
import { ProfileHeader } from "./ProfileHeader";
import { AboutSection } from "./AboutSection";
import { ShowcaseSection } from "./ShowcaseSection";
import { TagSection } from "./TagSection";
import useUserStore from "../../stores/userStore";
export default function UserProfileContainer() {
  return (
    <HeaderAndSidebar>
      <UserProfile />
    </HeaderAndSidebar>
  );
}

 function UserProfile() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [chatId, setChatId] = useState(undefined);

  const {
    user: { id: currentUserId, admin },
  } = useUserStore((state) => state.user);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchApi(`/profile/user/${id}`, "GET");

        if (response.ok) {
          const res = await response.json();
          setUser(res);
        } else {
          const msg = (await response.json()).error;
          console.error(msg);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (

          <Loader color="indigo" size="lg" variant="dots" className="mx-auto mt-10" />
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen bg-[#F7F9FB] flex items-center justify-center">
        <div className="text-center">
          <Text>User not found</Text>
          <Text mt="sm">The profile you're looking for doesn't exist.</Text>
        </div>
      </div>
    );
  }

  // Prepare data for components
  const tags = {
    expertise: user.expert_in || [],
    industry: user.industries || [],
    skills: user.skills || [],
  };

  const aboutText = user.about_me || "No description available.";

  // Map user memberships to showcase items
  const showcase = user.memberships?.map((member, index) => ({
    id: member.id || index + 1,
    title: member.startup_entity.name,
    subtitle: member.startup_entity.description || `${member.role === "owner" ? "Owner" : "Member"} at ${member.startup_entity.name}`,
    industry: member.startup_entity.industry || "Startup",
    location: member.startup_entity.country || "Remote",
    role: member.team_role_name || "Member",
    since: moment(member.created_at).format("MMM YYYY"),
    imageUrl: member.startup_entity.avatar_url || null,
    slug: member.startup_entity.slug,
    isFollowing: member.startup_entity.is_following || false,
  })) || [];
    
  
  return (
    <div className="min-h-screen bg-[#F7F9FB] flex">
      <div className="flex-1 overflow-auto">
        <div className="mx-auto max-w-[1750px] md:px-12">
          {/* Single 12-col grid: left stacks content, right rail is sticky */}
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
            {/* Left column: header + about + showcase */}
            <div className="lg:col-span-9 space-y-8">
              <ProfileHeader
                name={`${user.first_name || ''} ${user.last_name || ''}`.trim() || 'User'}
                subtitle={user.job_title ? `${user.job_title} at ${user.company || 'Company'}` : `Student at ${user.university} University`}
                followers={user.followers_count || '0'}
                following={user.following_count || '0'}
                avatarUrl={user.avatar?.url || ""}
                userId={id}
                isFollowing={user.is_following}
                onFollowToggle={() => handleFollowUnfollow(id, user.is_following, user, setUser)}
                setChatId={setChatId}
                hideActions={String(id) === String(currentUserId)}
              />
              <AboutSection description={aboutText} />
              <ShowcaseSection items={showcase} />
            </div>

            {/* Right column: sticky tag rail */}
            <aside className="lg:col-span-3 lg:sticky lg:top-6 self-start space-y-6" aria-label="profile-aside">
              <TagSection title="Expertise" items={tags.expertise} colored colorIndex={0} />
              <TagSection title="Skills" items={tags.skills} colored   colorIndex={1}/>
              <TagSection title="Industry" items={tags.industry} colored  colorIndex={2}/>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}
